import React from 'react';
import logoBlack from '../../../assets/logo-noir.png';

import CONFIG from '../../../config';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetSelect from '../../../components/widgets/WidgetSelect';

import 'dayjs/locale/fr';
import axios from "axios";
import Base64 from 'crypto-js/enc-base64';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HomeIcon from '@mui/icons-material/Home';
import Link from '@mui/material/Link';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import sha256 from 'crypto-js/sha256';
import WorkIcon from '@mui/icons-material/Work';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import WidgetInputVille from '../../../components/widgets/WidgetInputVille';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';


function InscriptionIntranet({ }) {
  const navigate = useNavigate();

  const [secteurOption, setSecteurOption] = React.useState({});
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_secteurs', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            let res = {};
            for (let i = 0; i < response.data.length; i++) {
              const secteurItem = response.data[i];
              res[secteurItem.toLowerCase()] = secteurItem;
            }
            res["autre"] = "Autre...";

            setSecteurOption(res);
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get("code");
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_client_fromcode/' + code, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setUser(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);

  /* START: FORM */
  const [nom, setNom] = React.useState(null);
  const [prenom, setPrenom] = React.useState(null);
  const [email, setEmail] = React.useState(null);
  const [telephone, setTelephone] = React.useState(null);
  const [motDePasse, setMotDePasse] = React.useState(null);
  const [motDeDasseBis, setMotDeDasseBis] = React.useState(null);

  const [secteur, setSecteur] = React.useState(null);
  const [externe, setExterne] = React.useState(null);
  const [salaire, setSalaire] = React.useState(null);
  const [prime, setPrime] = React.useState(null);
  const [tva, setTva] = React.useState(null);

  const [disponibilite, setDisponibilite] = React.useState(null);
  const [dateRetourConge, setDateRetourConge] = React.useState(null);
  // const [rgpdAccepte, setRgpdAccepte] = React.useState(null);

  const formCreation = [
    [nom, setNom],
    [prenom, setPrenom],
    [email, setEmail],
    [telephone, setTelephone],
    [motDePasse, setMotDePasse],
    [motDeDasseBis, setMotDeDasseBis],

    [secteur, setSecteur],
    [externe, setExterne],
    [salaire, setSalaire],
    [prime, setPrime],
    [tva, setTva],

    [disponibilite, setDisponibilite],
    [dateRetourConge, setDateRetourConge],
    // [rgpdAccepte, setRgpdAccepte]
  ];
  /* END: FORM */


  const [currentPage, setCurrentPage] = React.useState(0);


  React.useEffect(() => {
    if (motDePasse !== null && motDeDasseBis !== null) {
      if (motDePasse.value !== motDeDasseBis.value) {
        if (!motDeDasseBis.error)
          setMotDeDasseBis((s) => ({ ...s, error: true, errorMessage: "Le mot de passe est différent" }));
      } else {
        if (motDeDasseBis.error)
          setMotDeDasseBis((s) => ({ ...s, error: false, errorMessage: null }));
      }
    }
  }, [motDePasse, motDeDasseBis]);


  const submitForm = () => {
    var formCreationValid = true;

    if (nom === null || nom.value === '') {
      setNom((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (prenom === null || prenom.value === '') {
      setPrenom((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (email === null || email.value === '') {
      setEmail((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (telephone === null || telephone.value === '') {
      setTelephone((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (motDePasse === null || motDePasse.value === '' || !(new RegExp("^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[\\W_])(.{9,})$")).test(motDePasse.value)) {
      setMotDePasse((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (motDeDasseBis === null || motDeDasseBis.value === '') {
      setMotDeDasseBis((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (motDePasse.value !== motDeDasseBis.value) {
      formCreationValid = false;
    }


    if (secteur === null || secteur.value === '') {
      setSecteur((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (externe === null) {
      setExterne((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (salaire === null || salaire.value === '') {
      setSalaire((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (prime === null || prime.value === '') {
      setPrime((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (tva === null) {
      setTva((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (disponibilite === null || disponibilite.value === '') {
      setDisponibilite((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    if (dateRetourConge === null || dateRetourConge.value === null) {
      setDateRetourConge((s) => ({ ...s, error: true }));
      formCreationValid = false;
    }

    // if (rgpdAccepte === null || !rgpdAccepte.value) {
    //   setRgpdAccepte((s) => ({ ...s, error: true, errorMessage: "Vous devez accepter ..." }));
    //   formCreationValid = false;
    // }


    if (!formCreationValid) {
      return;
    }


    var payload = {};

    for (var i = 0; i < formCreation.length; i++) {
      let [field, setField] = formCreation[i];
      if (field !== null && field.value !== null && field.value !== '') {
        payload[field.id] = dayjs.isDayjs(field.value) ? field.value.toISOString() : field.value;
      }
    }

    payload['mot_de_passe'] = Base64.stringify(sha256(motDePasse.value));

    axios.post(CONFIG.API_URL + '/api/client_create_user_intranet/' + code, payload)
      .then((response) => {
        switch (response.status) {
          case 200:
            setCurrentPage(1);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 412:
            for (var i = 0; i < formCreation.length; i++) {
              let [field, setField] = formCreation[i];
              if (field !== null && field.id in response.data.detail.creation) {
                setField((s) => ({ ...s, error: true, errorMessage: response.data.detail.creation[field.id] }));
              }
            }
            break;

          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  };


  return (
    <>
      {user !== null &&
        <>
          <div className='max-w-4xl mx-auto shrink-0' style={{ display: (currentPage === 0) ? 'grid' : 'none' }}>
            <div className='grid grid-cols-12 gap-x-4 m-6'>
              <div className='col-span-12 w-full text-center'>
                <h1>Créons votre <b>espace intranet</b></h1>
                Les champs obligatoires apparaîtront en surbrillance si manquants.
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <PersonIcon fontSize='large'></PersonIcon>
                </div>
                <div>
                  <h2>Informations personnelles</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={nom} setState={setNom} id={'nom'} text={"Nom"} value={user.nom} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={prenom} setState={setPrenom} id={'prenom'} text={"Prénom"} value={user.prenom} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={email} setState={setEmail} id={'email'} text={"Email"} regex={"^.+@.+$"} regex_helper={"Adresse email non-valide"} value={user.email} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={telephone} setState={setTelephone} id={'telephone'} text={"Téléphone"} regex_key={"[+0-9 ]"} value={user.telephone} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={motDePasse} setState={setMotDePasse} id={'mot_de_passe'} text={"Mot de passe"} type={'password'} regex={"^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[\\W_])(.{9,})$"} tips={"Votre mot de passe doit comporter au moins : une minuscule, une majuscule, un chiffre, un symbole, et 9 caractères"} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={motDeDasseBis} setState={setMotDeDasseBis} id={'mot_de_passe_bis'} text={"Confirmez le mot de passe"} type={'password'} />
              </div>
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <WorkIcon fontSize='large'></WorkIcon>
                </div>
                <div>
                  <h2>Information commercial</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={secteur} setState={setSecteur} id={'secteur'} text={"Secteur"} value={user.informations_admin.secteur}
                  options={secteurOption}
                />
              </div>

              <div className='col-span-6 w-full mb-4 content-center grid pl-2'>
                <WidgetCheckbox state={externe} setState={setExterne} id={'externe'} text={"Interne"} value={user.informations_admin.externe} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={salaire} setState={setSalaire} id={'salaire'} text={"Salaire"} value={user.informations_admin.salaire} />
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetInputText state={prime} setState={setPrime} id={'prime'} text={"Prime"} value={user.informations_admin.prime} />
              </div>

              <div className='col-span-12 w-full mb-4 content-center grid pl-2'>
                <WidgetCheckbox state={tva} setState={setTva} id={'tva'} text={"TVA"} value={user.informations_admin.tva} />
              </div>
            </div>



            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0 p-6 pb-2 bg-white my-shadow'>
              <div className='flex col-span-12 w-full mb-1 text-center items-end'>
                <div className='pr-2 text-ame-gray'>
                  <AccessTimeFilledIcon fontSize='large'></AccessTimeFilledIcon>
                </div>
                <div>
                  <h2>Disponibilités</h2>
                </div>
              </div>

              <div className='col-span-12 w-full mb-4'>
                <hr></hr>
              </div>

              <div className='col-span-6 w-full mb-4'>
                <WidgetSelect state={disponibilite} setState={setDisponibilite} id={'disponibilite'} text={"Disponivilités"} value={user.informations_admin.disponibilite}
                  options={{
                    'osef': "Non-renseigné",
                    'conge': "En congé",
                    '0d': "Pas de disponibilité",
                    '1d': "1 Disponibilité",
                    '2d': "2 Disponibilités",
                    '3d+': "3 Disponibilités ou plus"
                  }}
                />
              </div>

              {disponibilite !== null && disponibilite.value === 'conge' &&
                <div className='col-span-6 w-full mb-4 grid'>
                  <WidgetDatePicker state={dateRetourConge} setState={setDateRetourConge} id={'date_retour_conge'} text={"Date de retour de congé"} value={user.informations_admin.date_retour_conge} />
                </div>
              }

              {/* <div className='col-span-12 w-full mb-4 content-center grid pl-2'>
                <WidgetCheckbox state={rgpdAccepte} setState={setRgpdAccepte} id={'rgpd_accepte'} text={"<Phrase RGPD>"} />
              </div> */}
            </div>

            <div className='grid grid-cols-12 gap-x-4 m-6 mt-0'>
              <div className='col-span-12 w-full text-right'>
                <div className='inline'>
                  <Button variant='contained' onClick={() => { submitForm() }}>
                    Créer mon espace
                  </Button>
                </div>
              </div>
              <div className='col-span-12 w-full mt-6 text-xs text-justify'>
                En tant que responsable de traitement, Mouv'Immo collecte vos données à caractère personnel aux fins notamment
                de la création et de la gestion de votre compte utilisateur, de la gestion de la relation commerciale, de la réalisation
                d'enquêtes de satisfaction, d'études marketing et statistiques. Vos données sont destinées aux différents services
                administratifs, commercial, marketing de Mouv'Immo. Vos données seront conservées le temps nécessaire à
                l'exécution des différentes démarches et selon notre politique de conservation des données. Les données mentionnées
                par un astérisque (*) sont obligatoires. Conformément à la Loi Informatique et Liberté Loi n° 78-17 du 6 janvier 1978
                modifiée et au Règlement Général sur la Protection des Données Règlement (UE) 2016/679 du Parlement européen et
                du Conseil du 27 avril 2016 dit RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et
                d'opposition au traitement de vos données. Vous pouvez exercer vos droits en envoyant un mail à agence@amerelocation.com ou par courrier à Mouv'Immo, 16 rue Lieutenant-Colonel Prévost, 69006 Lyon. Pour plus
                d'informations concernant le traitement de vos données à caractère personnel, vous pouvez consulter notre politique
                en ligne.
              </div>
            </div>
          </div>

          <div className='m-6 grid-cols-12 gap-x-4 shrink-0 p-6 max-w-lg mx-auto bg-white my-shadow' style={{ display: (currentPage === 1) ? 'grid' : 'none' }}>
            <div className='col-start-3 col-span-8 w-full item-center mb-6'>
              <img src={logoBlack} alt="Logo" />
            </div>

            <div className='col-span-12 w-full mb-4 text-center'>
              <h1>Félicitation, <b>votre espace est créé</b></h1>
            </div>

            <div className='col-start-2 col-span-10 w-full text-center bg-green-200 rounded-md p-2'>
              Vous pouvez maintenant <Link variant='contained' href={CONFIG.BASE_URL + "/connexion"}><span className='text-black underline decoration-black hover:decoration-2'>vous connecter</span></Link>.
            </div>
          </div>
        </>
      }
    </>
  );
}

export default InscriptionIntranet;